import FieldPriority from "../../../generic/priority/priority";
import FieldConfig from "../../../proto/field-config";
import Project from "../../../../model2/project/project";
import ItemModel from "../../../../model2/item/item-model";
import TableManager from "../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../gd-modules/task-list/manager/manager";

export default class FieldProjectPriority extends FieldPriority {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Project priority";
        this.label      = _.get(config, 'label', "Project priority")


        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangePriority
    }

    tableCellOnValueChange = (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {

        item.project.priority = value
        item.project.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }


}